import React from 'react';
import { AlertTriangle } from 'lucide-react';

export function MedicalDisclaimer({ text, compact = false }) {
  if (!text) return null;

  if (compact) {
    return (
      <div className="flex items-start gap-2 px-3 py-2 rounded-lg bg-amber-50/80 dark:bg-amber-900/10 border border-amber-200/50 dark:border-amber-700/30" data-testid="medical-disclaimer">
        <AlertTriangle className="w-3.5 h-3.5 text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
        <p className="text-[10px] leading-relaxed text-[#1A1A18] dark:text-[#1A1A18]">{text}</p>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3 p-4 rounded-xl bg-amber-50/80 dark:bg-amber-900/10 border border-amber-200/50 dark:border-amber-700/30" data-testid="medical-disclaimer">
      <AlertTriangle className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
      <p className="text-xs leading-relaxed text-[#1A1A18] dark:text-[#1A1A18]">{text}</p>
    </div>
  );
}
